import { workflowsRepo } from '@/constants/providers';
import { useMutation } from '@tanstack/react-query';
import { UpdateWorkflowDto } from '../types';

export const useUpdateWorkflow = () =>
  useMutation<unknown, unknown, UpdateWorkflowDto>((workflow) =>
    workflowsRepo.updateWorkflow(workflow),
  );
